import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useState } from 'react'
import { Badge, Button, Col, Form, InputGroup, Row } from 'react-bootstrap'
import Alert from 'react-bootstrap/Alert'
import Select from '~/components/select'
import Spinner from '~/components/spinner'
import { patchJSON } from '~/utils/patch_json'
import { postJSON } from '~/utils/post_json'

export default function TagTemplatesManager(props) {
  const [name, setName] = useState(props.name || '')
  const [tags, setTags] = useState(props.tags || [])
  const [tagKey, setTagKey] = useState('')
  const [tagValue, setTagValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState([])
  const [group, setGroup] = useState(props.group || '')

  const handleAddTag = () => {
    if (tagKey.trim()) {
      setTags([...tags, { key: tagKey, value: tagValue }])
      setTagKey('')
      setTagValue('')
    }
  }

  const handleRemoveTag = (index) => {
    setTags(tags.filter((_, i) => i !== index))
  }

  const groupOptions = () => {
    return props.groups.map((acc) => ({ value: acc.value, label: acc.label }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const params = {
      name,
      tags,
      group,
    }
    const requestFunction = props.method === 'post' ? postJSON : patchJSON
    const { request } = requestFunction(props.url, { tag_template: params })
    setIsLoading(true)

    request
      .then((data) => {
        setIsLoading(false)
        setErrors([])
        window.location.assign(data.url)
      })
      .catch((err) => {
        err.response.json().then((json) => {
          setErrors(json.errors)
        })
        setIsLoading(false)
      })
  }

  const tagPresent = () => {
    return !!tagKey && !!tagValue
  }

  const handleGroupChange = (_selectName, selectedValue) => {
    setGroup(selectedValue)
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group controlId='formName'>
            <Form.Label>
              <Trans>Name</Trans>
            </Form.Label>
            <Form.Control
              type='text'
              placeholder={t`Enter name`}
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group controlId='formName'>
            <Select
              name='group-select'
              label={t`Group`}
              options={groupOptions()}
              onChange={handleGroupChange}
              selected={group}
            />
          </Form.Group>
        </Col>
      </Row>

      <Form.Label className='mt-3'>
        <Trans>Tags</Trans>
      </Form.Label>
      <InputGroup className='mb-2'>
        <Row className='g-2 w-100'>
          <Col md={6}>
            <Form.Control
              type='text'
              placeholder={t`Tag key. skieio:monitoring:create_alarms`}
              value={tagKey}
              name='tag_key'
              onChange={(e) => setTagKey(e.target.value)}
            />
          </Col>
          <Col>
            <Form.Control
              type='text'
              placeholder={t`Tag value`}
              value={tagValue}
              name='tag_value'
              onChange={(e) => setTagValue(e.target.value)}
            />
          </Col>
          <Col xs='auto'>
            <Button variant='primary' disabled={!tagPresent()} onClick={handleAddTag}>
              <Trans>Add</Trans>
            </Button>
          </Col>
        </Row>
      </InputGroup>

      <div className='mt-3'>
        {tags.map((tag, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: todo: fix this
          <Badge key={index} pill bg='primary' text='white' className='me-2 p-2'>
            {tag.key}
            {tag.value ? `: ${tag.value}` : ''}
            <Button variant='link' className='text-white ms-2 p-0' onClick={() => handleRemoveTag(index)}>
              ✕
            </Button>
          </Badge>
        ))}
      </div>

      {errors.length > 0 && (
        <Alert key='danger' variant='danger'>
          <div>
            <Trans>Errors:</Trans>
          </div>
          <ul>
            {errors.map((error) => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}

      <Button variant='primary' type='submit' className='mt-3'>
        <Trans>Submit</Trans>
      </Button>

      {isLoading && <Spinner />}
    </Form>
  )
}
